<template>
    <div>
        <h2><router-link :to="{ name: 'stock' }">สต็อก</router-link> > แยกตามคลัง</h2>
        <v-card class="mt-4 px-6 pt-6">
            <v-row>
              <v-col>
                <delay-autocomplete
                  outlined
                  hide-selected
                  deletable-chips
                  multiple
                  chips
                  cache-items
                  v-model="datatable.warehouse_id"
                  label="คลัง"
                  placeholder="พิมพ์เพื่อค้นหาคลัง"
                  no-data-text="ไม่พบข้อมูล"
                  :url="'/inventory/warehouseList'"
                  dense
                  :lazySearch="true"
                  return-object
                  ref="warehouseAutocomplete"
                  item-text="name"
                  item-value="id"
                ></delay-autocomplete>
              </v-col>
            </v-row>
        </v-card>
        <v-card class="mt-4">
          <v-row class="align-center">
            <v-col cols="1"
            >
              <v-btn
              icon
              @click="$router.go(-1)"
              ><v-icon>{{ mdiChevronLeft }}</v-icon></v-btn>
            </v-col>
            <template v-if="!!product">
              <v-col cols="1">
                <product-image :image="product.images[0] ? product.images[0].URI : null" />
              </v-col>
              <v-col>
                {{ product.name }}
              </v-col>
              <v-col>
                {{ product.sku }}
              </v-col>
              <v-col>
                {{ product.brand ? product.brand.name : '-' }}
              </v-col>
              <v-col cols="1">
                {{ getQuantitySum }}
              </v-col>
              <v-col cols="1">
                {{ getReservedSum }}
              </v-col>
              <v-col cols="1">
                {{ getQuantitySum - getReservedSum }}
              </v-col>
            </template>
          </v-row>
          <delay-datatable
            :headers="datatable.headers"
            :options.sync="datatable.options"
            :url="'/inventory/' + $route.params.product_id + '/listbyproduct'"
            :queryParams="getDatatableQueryParams"
            @loadState="loadDatatableState"
            ref="mainDatatable"
          >

          <template
            v-slot:item.reserved="{ item }"
          >
          <router-link :to="{ name: 'stock_reserved', params: { stock_id: item.id } }">{{ item.reserved }}</router-link>
          </template>

          <template
            v-slot:item.actions="{ item }"
          >
            <v-btn
              icon
              @click="callEditModal(item)"
              v-if="$store.getters['auth/GET_ABILITY'].can('update', 'Stock')"
            ><v-icon>{{ mdiPlaylistEdit }}</v-icon></v-btn>
            <v-btn
              icon
              @click="$router.push({ name: 'stock_history', params: { stock_id: item.id }, query: { warehouses: converters.jsonToBase64(datatable.warehouse_id) } })"
            ><v-icon>{{ mdiHistory }}</v-icon></v-btn>
          </template>
          </delay-datatable>
        </v-card>
        <v-dialog
          v-model="editDialog.isOpen"
          width="400"
          persistent
        >
          <v-card class="py-8 px-6">
            <v-form v-model="editDialog.isFormValid">
              <v-row no-gutters>
                <v-col>
                  <label for="" class="text-h6">ปรับสต็อค &gt; {{ editDialog.warehouse }}</label>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col>
                  <label for="" class="text-caption">อัพเดธจำนวนสินค้า</label>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <product-image :image="!!product && !!product.images && !!product.images[0] ? product.images[0].URI : null" />
                </v-col>
                <v-col cols="8" class="d-flex align-center">
                  <div class="d-flex flex-column">
                    <label for="">{{ product ? product.name : '' }}</label>
                    <label class="mt-2 text-subtitle-2">{{ product ? product.sku : '' }}</label>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col>จำนวนปัจจุบัน</v-col><v-col class="text-right">{{ editDialog.currentQuantity }}</v-col>
              </v-row>
              <v-row>
                <v-col>จำนวนติดจอง</v-col><v-col class="text-right">{{ editDialog.currentReserved }}</v-col>
              </v-row>
              <v-row>
                <v-text-field
                  outlined
                  v-model.number="editDialog.newQuantity"
                  label="จำนวนสินค้าใหม่ *"
                  dense
                  :rules="[validators.required]"
                ></v-text-field>
              </v-row>
              <v-row>
                <v-text-field
                  outlined
                  v-model="editDialog.note"
                  label="เหตุผล *"
                  :rules="[validators.required, validators.minLengthValidator(editDialog.note, 5), validators.maxLengthValidator(editDialog.note, 250)]"
                  counter="250"
                  dense
                ></v-text-field>
              </v-row>
            </v-form>
            <v-card-actions class="justify-center mt-4">
              <v-btn
                text
                @click="editDialog.isOpen = false"
                :disabled="editDialog.isSubmitting"
              >ยกเลิก</v-btn>
              <v-btn
                color="primary"
                @click="updateStock()"
                :disabled="!editDialog.isFormValid"
                :loading="editDialog.isSubmitting"
              >แก้ไข</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </div>
</template>
<script>
import ProductImage from '@/components/ProductImage.vue'
import { asyncGet, asyncUpdate } from '@/helpers/asyncAxios'
import { base64ToJson, jsonToBase64 } from '@/helpers/converter.js'
import { mdiChevronLeft, mdiHistory, mdiPlaylistEdit } from '@mdi/js'
import { maxLengthValidator, minLengthValidator, required } from '@core/utils/validation'
export default {
  data() {
    return {
      product: null,
      editDialog: {
        isOpen: false,
        isSubmitting: false,
        isFormValid: false,
        warehouse: '',
        currentQuantity: 0,
        currentReserved: 0,
        newQuantity: null,
        inventoryId: null,
        note: null,
      },
      datatable: {
        brand_id: null,
        warehouse_id: null,
        search: null,
        options: {},
        headers: [
          {
            text: 'คลัง',
            value: 'warehouse_name',
          },
          {
            text: 'จำนวน',
            value: 'quantity',
            width: 150,
          },
          {
            text: 'ติดจอง',
            value: 'reserved',
            width: 150,
          },
          {
            text: 'ขายได้',
            value: 'sum_available',
            width: 150,
          },
          {
            text: '#',
            value: 'actions',
            sortable: false,
            align: 'center',
            width: 150,
          },
        ],
      },
      mdiPlaylistEdit,
      mdiHistory,
      mdiChevronLeft,
      validators: {
        required,
        maxLengthValidator,
        minLengthValidator,
      },
      converters: {
        jsonToBase64,
      },
    }
  },
  computed: {
    getDatatableQueryParams() {
      return {
        warehouse_id: this.datatable.warehouse_id,
      }
    },
    getQuantitySum() {
      if (!this.product) return 0

      let inventory = this.product.inventory

      if (!!this.datatable.warehouse_id && this.datatable.warehouse_id.length != 0)
        inventory = inventory.filter(inventory =>
          this.datatable.warehouse_id.find(warehouse_id => inventory.warehouse_id == warehouse_id.id),
        )

      if (!inventory) return 0

      return inventory
        .map(inventory => inventory.quantity)
        .reduce((total, currentQuantity) => {
          return total + currentQuantity
        })
    },
    getReservedSum() {
      if (!this.product) return 0

      let inventory = this.product.inventory

      if (!!this.datatable.warehouse_id && this.datatable.warehouse_id.length != 0)
        inventory = inventory.filter(inventory =>
          this.datatable.warehouse_id.find(warehouse_id => inventory.warehouse_id == warehouse_id.id),
        )

      if (!inventory) return 0

      return inventory
        .map(inventory => inventory.reserved)
        .reduce((total, currentReserved) => {
          return total + currentReserved
        })
    },
  },
  async created() {
    if (this.$route.query.warehouses) {
      const warehouse_id = base64ToJson(this.$route.query.warehouses)

      this.datatable.warehouse_id = warehouse_id
    }

    const product_id = this.$route.params.product_id

    this.$store.commit('app/SET_GLOBAL_LOADING', true)
    try {
      const response = await asyncGet('/inventory/' + product_id + '/getbyproduct')

      this.product = response

      this.$refs.mainDatatable.reload()
    } catch (error) {
      this.$root.showCommonDialog('มีปัญหา', error)
    }
    this.$store.commit('app/SET_GLOBAL_LOADING', false)
  },
  methods: {
    loadDatatableState({ options, queryParams }) {
      this.datatable = { ...this.datatable, options: { ...options }, ...queryParams }
    },
    isArray(data) {
      return Array.isArray(data)
    },
    callEditModal({ quantity, reserved, warehouse_name, id }) {
      this.editDialog.isOpen = true
      this.editDialog.isSubmitting = false

      this.editDialog.currentQuantity = quantity
      this.editDialog.currentReserved = reserved
      this.editDialog.warehouse = warehouse_name
      this.editDialog.newQuantity = null
      this.editDialog.inventoryId = id
      this.editDialog.note = null
    },
    async updateStock() {
      this.editDialog.isSubmitting = true
      const diff = this.editDialog.newQuantity - this.editDialog.currentQuantity

      try {
        await asyncUpdate('/inventory/' + this.editDialog.inventoryId, {
          diff: diff,
          note: this.editDialog.note,
        })
      } catch (error) {
        this.$root.showCommonDialog('มีปัญหา', error)
      }

      this.$refs.mainDatatable.reload()
      this.editDialog.isSubmitting = false
      this.editDialog.isOpen = false
    },
  },
  components: {
    ProductImage,
  },
}
</script>
